import { __decorate } from "tslib";
import Modal from "@/components/Modal.vue";
import ModalMixin from "@/mixins/modal-mixin";
import { Component, Mixins, Prop } from "vue-property-decorator";
let AddFieldModal = class AddFieldModal extends Mixins(ModalMixin) {
    id;
    initialData;
    fields;
    action;
    field = {};
    errors = {};
    get availableDependers() {
        return this.fields.map(field => {
            return { text: field.label, value: field.name };
        });
    }
    get fieldTypes() {
        return [
            { text: 'Small text field', value: 'text' },
            { text: 'Large text field', value: 'textarea' },
            { text: 'Dropdown list', value: 'select' },
            { text: 'Radio list', value: 'radio' },
            { text: 'Checkboxes', value: 'checkbox' },
        ];
    }
    fieldWillHaveOptions(field) {
        if (!field.type)
            return false;
        const typesWithOptions = ['select', 'radio', 'checkbox'];
        return typesWithOptions.includes(field.type);
    }
    shown() {
        this.field = JSON.parse(JSON.stringify(this.initialData));
    }
    hidden() {
        this.field = {};
    }
    use() {
        this.$root.$emit('bv::hide::modal', this.id);
        // @ts-ignore
        this.action(this.field);
    }
    validation(field) {
        if (this.errors && this.errors[field])
            return false;
        else
            return null;
    }
    slugify(overwrite) {
        if (!this.field.label)
            return;
        const label = this.transliterate(this.field.label);
        const slugified = label
            .toLowerCase()
            .trim()
            .replace(/[^\w\s-]/g, '')
            .replace(/[\s_-]+/g, '-')
            .replace(/^-+|-+$/g, '');
        if (overwrite) {
            this.field.name = slugified;
        }
        else if (!this.field.name) {
            this.field.name = slugified;
        }
    }
    transliterate(word) {
        return this.$toLatinRegex(word);
    }
};
__decorate([
    Prop({ type: String, required: true })
], AddFieldModal.prototype, "id", void 0);
__decorate([
    Prop({ type: Object, required: true })
], AddFieldModal.prototype, "initialData", void 0);
__decorate([
    Prop({ type: Array, required: true })
], AddFieldModal.prototype, "fields", void 0);
__decorate([
    Prop({ type: Function, required: true })
], AddFieldModal.prototype, "action", void 0);
AddFieldModal = __decorate([
    Component({
        name: 'add-field-modal',
        components: {
            Modal,
        },
    })
], AddFieldModal);
export default AddFieldModal;
